import { useState } from "react";
import { usePreventBackModal } from "./usePreventBackModal";

type Modal = {
  open: boolean;
  openModal: () => void;
  closeModal: () => void;
};

type UseModal = {
  enable?: boolean;
  disablePreventBack?: boolean;
};

/**
 * Returns a object with the modal state and functions to open and close it.
 */
export function useModal({ enable, disablePreventBack }: UseModal = {}): Modal {
  const [open, setOpen] = useState(enable ?? false);

  const openModal = (): void => setOpen(true);
  const closeModal = (): void => setOpen(false);

  usePreventBackModal({ open, disabled: disablePreventBack, onClose: closeModal });

  return { open, openModal, closeModal };
}
